import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function SubmitButton({ disabled, text, onSubmit }) {
  const submitButtonClass = cx(
    'btn',
    'm-btn--pill',
    'btn-dynamic',
    'm-btn--wide',
    'loader-button',
  );

  return (
    <div className="quiz-answer-submit-container">
      <button
        type="button"
        className={submitButtonClass}
        onClick={onSubmit}
        disabled={disabled}
      >
        {text}
      </button>
    </div>
  );
}

SubmitButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
